"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");

var NewSalesDashboardReportRowConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(NewSalesDashboardReportRowConverter, _DataObjectConverter_);

  function NewSalesDashboardReportRowConverter() {
    _classCallCheck(this, NewSalesDashboardReportRowConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(NewSalesDashboardReportRowConverter).apply(this, arguments));
  }

  return NewSalesDashboardReportRowConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.NewSalesDashboardReportRowConverter = NewSalesDashboardReportRowConverter;